import React, { useState, useEffect } from "react";
import DiscountItem from "./DiscountItem";
import RewardsItem from "./RewardsItem";
import { connect } from "react-redux";
import {
  fixedAmount,
  percentageCoupon,
  freeShippingCoupon,
  spendYourPoints,
} from "../../helpers/icons";
import {
  setCurrentDiscountCode,
  setCurrentGiftcard,
} from "../../actions/customerActions";
import { BiArrowBack } from "react-icons/bi";
import { FaRegFrownOpen } from "react-icons/fa";
import { languages } from "../../helpers/language";
import GiftcardItem from "./GiftcardItem";
import { setIsDiscountCard } from "../../actions/appstateActions";

const RewardsSection = ({
  rewardsRef,
  customerData,
  merchantData,
  setCurrentDiscountCode,
  setCurrentGiftcard,
  appStateData,
  setIsDiscountCard,
}) => {
  let { merchant, currencySymbol } = merchantData;
  let { customer, giftcards } = customerData;
  const { isDiscountCard, shopDomain } = appStateData;
  const isGermanLang = shopDomain === "nui-cosmetics.myshopify.com";

  const [viewAllRewards, setViewAllRewards] = useState(false);
  // const [isDiscountCard, setIsDiscountCard] = useState(false);
  const [isGiftCard, setIsGiftCard] = useState(false);
  const [discountCodesFew, setDiscountCodesFew] = useState([]);
  const [discountCodes, setDiscountCodes] = useState([]);
  const [giftcardsFew, setGiftcardsFew] = useState([]);

  useEffect(() => {
    let fewDiscountCodes = customer?.discountCodes
      ?.filter((discountCode) => !discountCode?.used)
      ?.reverse()
      ?.slice(0, 2);
    setDiscountCodesFew(fewDiscountCodes);
    setDiscountCodes(
      customer?.discountCodes?.filter((discountCode) => !discountCode?.used)
    );
  }, [customer]);

  useEffect(() => {
    if (!Array.isArray(giftcards)) return;
    let fewGiftcards = giftcards?.reverse()?.slice(0, 2);
    setGiftcardsFew(fewGiftcards);
  }, [giftcards]);

  let details = {
    main_your_rewards:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.your_rewards"
      ],

    discount_off:
      languages[merchant?.customWidgetTheme?.language || "en"]["discount.off"],
    points_spent:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "discount.points_spent"
      ],

    balance:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "giftcard.balance"
      ],
    title_gift:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "giftcard.title_gift"
      ],
    title_card:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "giftcard.title_card"
      ],
    copy_code:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "giftcard.copy_code"
      ],
    copied:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "giftcard.copied"
      ],
    rewards_go_back:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "rewards.go_back"
      ],

    rewards_view_all:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "rewards.view_all"
      ],
    rewards_view_less:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "rewards.view_less"
      ],
    birthday_close:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "birthday.close"
      ],
    giftcard_order_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.giftcard_order_desc"
      ],
    redeem_fixed_coupon:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "redeem.percentage_coupon"
      ],
    your_rewards:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.your_rewards"
      ],
    main_points_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.points_title"
      ],
  };

  return (
    <div ref={rewardsRef} className="rewards-section-wrapper">
      <div className="rewards-heading-container">
        <h2 className="rewards-heading">
          {merchant?.currentPlan?.planName !== "free" &&
          merchant?.customWidgetTheme?.textCustomization
            ? merchant?.customWidgetTheme?.textCustomization?.yourRewards
            : details.your_rewards}
        </h2>
      </div>
      {discountCodes?.length === 0 &&
        (Array.isArray(giftcards) && giftcards?.length
          ? giftcards?.length
          : 0 === 0) && (
          <div className="rewards-no-rewards-container">
            {/* <FaRegFrownOpen className="rewards-no-rewards-icon" /> */}
            <span className="rewards-no-rewards-text">
              {isGermanLang
                ? "noch keine Belohnungen"
                : merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                ? merchant?.customWidgetTheme?.textCustomization?.noRewardsYet
                : "No rewards yet!"}
            </span>
          </div>
        )}
      <div className="rewards-items-warpper">
        {!isDiscountCard &&
          !isGiftCard &&
          !viewAllRewards &&
          discountCodesFew?.map((discountCode) => {
            let imgUrl = discountCode.desc.includes("%")
              ? percentageCoupon(merchant?.customWidgetTheme?.iconcolor)
              : discountCode.desc.includes(currencySymbol)
              ? fixedAmount(merchant?.customWidgetTheme?.iconcolor)
              : freeShippingCoupon(merchant?.customWidgetTheme?.iconcolor);
            return (
              <RewardsItem
                key={discountCode?.code}
                imgUrl={imgUrl}
                text={
                  merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                    ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                        "{{value}}",
                        discountCode.desc.split(" ")[0]
                      )
                    : `${discountCode.desc.split(" ")[0]} ${
                        details.redeem_fixed_coupon.split("%")[1]
                      }`
                }
                code={`******${discountCode?.code?.slice(-10)}`}
                rewardsItemHandler={() => {
                  setCurrentDiscountCode({
                    text:
                      merchant?.currentPlan?.planName !== "free" &&
                      merchant?.customWidgetTheme?.textCustomization
                        ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                            "{{value}}",
                            discountCode.desc.split(" ")[0]
                          )
                        : `${discountCode.desc.split(" ")[0]} ${
                            details.redeem_fixed_coupon.split("%")[1]
                          }`,
                    desc: `${discountCode?.pointSpent || 200} ${
                      merchant?.pointsCurrency !== "Super-Points"
                        ? merchant?.pointsCurrency
                        : details.main_points_title
                    } ${details.points_spent?.split(" ")[1]}`,
                    code: discountCode?.code,
                    imgUrl,
                    selectedOrder: discountCode?.selectedOrder,
                    collectionName: discountCode?.collectionName,
                    expiryDate: discountCode?.expiryDate,
                  });
                  setIsDiscountCard(true);
                }}
                used={discountCode?.used}
              />
            );
          })}
        {!isDiscountCard &&
          !isGiftCard &&
          viewAllRewards &&
          discountCodes?.map((discountCode) => {
            let imgUrl = discountCode.desc.includes("%")
              ? percentageCoupon(merchant?.customWidgetTheme?.iconcolor)
              : discountCode.desc.includes(currencySymbol)
              ? fixedAmount(merchant?.customWidgetTheme?.iconcolor)
              : freeShippingCoupon(merchant?.customWidgetTheme?.iconcolor);
            return (
              <RewardsItem
                key={discountCode?.code}
                imgUrl={imgUrl}
                text={
                  merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                    ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                        "{{value}}",
                        discountCode.desc.split(" ")[0]
                      )
                    : `${discountCode.desc.split(" ")[0]} ${
                        details.redeem_fixed_coupon.split("%")[1]
                      }`
                }
                code={`******${discountCode?.code?.slice(-10)}`}
                rewardsItemHandler={() => {
                  setCurrentDiscountCode({
                    text:
                      merchant?.currentPlan?.planName !== "free" &&
                      merchant?.customWidgetTheme?.textCustomization
                        ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                            "{{value}}",
                            discountCode.desc.split(" ")[0]
                          )
                        : `${discountCode.desc.split(" ")[0]} ${
                            details.redeem_fixed_coupon.split("%")[1]
                          }`,
                    desc: `${discountCode?.pointSpent || 200} ${
                      merchant?.pointsCurrency !== "Super-Points"
                        ? merchant?.pointsCurrency
                        : details.main_points_title
                    } ${details.points_spent?.split(" ")[1]}`,
                    code: discountCode?.code,
                    imgUrl,
                    selectedOrder: discountCode?.selectedOrder,
                    collectionName: discountCode?.collectionName,
                    expiryDate: discountCode?.expiryDate,
                  });
                  setIsDiscountCard(true);
                }}
                used={discountCode?.used}
              />
            );
          })}

        {/* few giftcards  */}
        {!isGiftCard &&
          !isDiscountCard &&
          !viewAllRewards &&
          giftcardsFew?.map((giftcard) => {
            return (
              <RewardsItem
                key={giftcard?.last_characters}
                imgUrl={spendYourPoints(merchant?.customWidgetTheme?.iconcolor)}
                text={`${currencySymbol}${giftcard.balance} ${details.title_gift}${details.title_card}`}
                code={`******${giftcard.last_characters}`}
                rewardsItemHandler={() => {
                  setCurrentGiftcard({
                    text: `${currencySymbol}${parseInt(giftcard.balance)} `,
                    code: giftcard?.code?.code,
                  });
                  setIsGiftCard(true);
                }}
              />
            );
          })}
        {/* all giftcards  */}
        {!isGiftCard &&
          !isDiscountCard &&
          viewAllRewards &&
          Array.isArray(giftcards) &&
          giftcards?.map((giftcard) => {
            return (
              <RewardsItem
                key={giftcard?.last_characters}
                imgUrl={spendYourPoints(merchant?.customWidgetTheme?.iconcolor)}
                text={`${currencySymbol}${giftcard.balance} ${details.title_gift}${details.title_card}`}
                code={`******${giftcard.last_characters}`}
                rewardsItemHandler={() => {
                  setCurrentGiftcard({
                    text: `${currencySymbol}${parseInt(giftcard.balance)} `,
                    code: giftcard?.code?.code,
                  });
                  setIsGiftCard(true);
                }}
              />
            );
          })}
      </div>
      {(isDiscountCard || isGiftCard) && (
        <div className="rewards-back-button-warpper">
          <button
            onClick={() => {
              setIsDiscountCard(false);
              setIsGiftCard(false);
            }}
            className="rewards-back-button"
          >
            <BiArrowBack className="rewards-back-button-icon" />
            {merchant?.currentPlan?.planName !== "free" &&
            merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.goBackButton
              : details.rewards_go_back}
          </button>
        </div>
      )}
      {(isDiscountCard || isGiftCard) && (
        <div className="rewards-discount-giftcard-wrapper">
          {isDiscountCard && <DiscountItem />}
          {isGiftCard && <GiftcardItem />}
        </div>
      )}

      {!isDiscountCard &&
        !isGiftCard &&
        (discountCodes?.length + giftcards?.length > 4 ||
          discountCodes?.length > 2 ||
          giftcards?.length > 2) && (
          <div className="rewards-detailview-button-container">
            <button
              className="rewards-detailview-button"
              onClick={() => setViewAllRewards(!viewAllRewards)}
            >
              {viewAllRewards
                ? merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization
                      ?.viewLessRewards
                  : details.rewards_view_less
                : merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                ? merchant?.customWidgetTheme?.textCustomization?.viewAllRewards
                : details.rewards_view_all}
            </button>
          </div>
        )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  customerData: state.CustomerReducer,
  merchantData: state.MerchantReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentDiscountCode: (discountcode) =>
    dispatch(setCurrentDiscountCode(discountcode)),
  setCurrentGiftcard: (giftcard) => dispatch(setCurrentGiftcard(giftcard)),
  setIsDiscountCard: (state) => dispatch(setIsDiscountCard(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RewardsSection);
